import React from 'react';
//import { withRouter } from 'react-router-dom';
import { PageSettings } from "./../config/page-settings.js";
//import { Api } from "./../app-controller.js";
import { useHistory } from "react-router-dom";
import { useAuth } from "../components/content/auth.jsx";

class EmailConfirm extends React.Component {
	static contextType = PageSettings;

	constructor(props) {
	super(props);
	
	this.state = {
		email:JSON.parse(localStorage.sesion).email
	};
   }
  
	componentDidMount() {
		this.context.handleSetPageSidebar(false);
		this.context.handleSetPageHeader(false);
		this.context.handleSetPageContentFullWidth(true);
		
	}

	componentWillUnmount() {
		this.context.handleSetPageSidebar(true);
		this.context.handleSetPageHeader(true);
		this.context.handleSetPageContentFullWidth(false);

	}
	
	
	render() {
		return (
			<div className="login login-v1">
				<div className="login-container">
					<div className="login-header">
						<div className="brand">
						{/* <span className="logo " ></span>  */}<img className="logo" alt="Logo" style={{width:"12%",height:"12%"}} src="../favicon.ico" ></img><b>SINAIP</b> 
						</div>
						<div className="icon">
							<i className="fa fa-envelope"></i>
						</div>
					</div>
					<div className="login-body">
						<div className="login-content">
							<div className="note note-warning note-with-right-icon">
								<div className="note-icon"><i className="fa fa-lightbulb"></i></div>
								<div className="note-content text-justify">
									<h4><b>Confirmar Cuenta</b></h4>
									<p> Se ha registrado en Sistema Integral Nacional de Insumos Pecuarios.<br /><br />
										Favor de verificar su correo electrónico <b>{this.state.email}</b> para validar su usuario antes de ingresar al sitio.<br /><br />
									{/* <p>Hola <b>{this.props.auth.user.name}</b> te enviamos un correo a <b>{this.props.auth.user.email}</b> Por favor revisa tu bandeja de entrada para confirmar tu cuenta.<br /><br /> */}
									<b>Nota:</b> Si aún no recibe el correo de confirmación, favor de revisar tu carpeta de correo no deseado. </p>
								</div>
							</div>
							<a href="/login">
							<button className="btn btn-block btn-lg btn-danger m-t-8 ">Regresar</button>
						</a>
						</div>
						
					</div>
				</div>
			</div>
		)
	}
}

//export default withRouter(EmailConfirm);
export default (props) => {
	const auth = useAuth();
	const history = useHistory();
	return <EmailConfirm auth={auth} history={history} {...props} />;
  };